import { Translator } from 'Translator';
import { Account } from 'model/IChat';
import React from 'react';
import { translateCity } from 'utils/TranslationHelper';
import { getHost } from 'utils/firstHost';

import CSS from './ExperienceCardTitle.module.scss';

interface ExperienceCardTitleProps {
  hosts: Account[];
  city: string;
  forceHost?: string;
  account: Account;
}

function ExperienceCardTitle({
  hosts = [],
  city,
  forceHost,
  account,
}: ExperienceCardTitleProps) {
  const host = getHost(hosts, account, forceHost);

  if (
    (!forceHost || (forceHost && host.id !== forceHost)) &&
    hosts.length > 1
  ) {
    const yourChoiceHTML = (
      <span className={CSS['experienceCard-hostName']}>
        {Translator.translate(
          'ExperienceCard.Details.yourChoice',
          {},
          true,
          'your choice',
        )}
      </span>
    );

    return (
      <span className={CSS['experienceCard-cityHostTitle']}>
        {Translator.translate(
          'ExperienceCard.Details.titleOriginals',
          { city: translateCity(city), yourChoice: yourChoiceHTML },
          false,
          'Enjoy {city} with a host of {yourChoice}',
        )}
      </span>
    );
  }

  const hostHTML = (
    <span className={CSS['experienceCard-hostName']}>{host?.firstName}</span>
  );

  return (
    <span className={CSS['experienceCard-cityHostTitle']}>
      {Translator.translate(
        'ExperienceCard.Details.title',
        { city: translateCity(city), hostName: hostHTML },
        false,
        'Enjoy {city} with {hostName}',
      )}
    </span>
  );
}

export default ExperienceCardTitle;
